function Header() {
  return (
    <h1 className="text-6xl font-sans mt-[40px]">Parts-of-speech Analyzer</h1>
  );
}

export default Header;
